const METAMASK_EXTENSION_ID = 'nkbihfbeogaeaoehlefnkodbefgpgknn';

const serializeConsoleArg = (value) => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (value instanceof Error) {
    return `${value.message} ${value.stack || ''}`;
  }
  if (typeof value === 'object') {
    return `${value.message || ''} ${value.reason || ''} ${value.stack || ''}`;
  }
  return String(value);
};

const isResizeObserverNoise = (...args) => {
  const text = args.map(serializeConsoleArg).join(' ');
  return /resizeobserver loop (completed with undelivered notifications|limit exceeded)/i.test(text);
};

const isExtensionConsoleNoise = (...args) => {
  const text = args.map(serializeConsoleArg).join(' ');
  if (isResizeObserverNoise(text)) {
    return true;
  }
  if (/resetting the streams/i.test(text)) {
    return true;
  }
  if (/metamask|failed to connect to metamask|wallet extension|ethereum provider/i.test(text)) {
    return true;
  }
  if (text.includes(METAMASK_EXTENSION_ID)) {
    return true;
  }
  return /chrome-extension:\/\//.test(text) && /inpage|metamask|wallet|contentscript/i.test(text);
};

const isWalletExtensionNoise = (value) => isExtensionConsoleNoise(value);

const dismissDevErrorOverlay = () => {
  const iframe = document.getElementById('webpack-dev-server-client-overlay');
  if (iframe) {
    iframe.remove();
  }

  document.querySelectorAll('body > div').forEach((node) => {
    const text = node.textContent || '';
    if (
      /failed to connect to metamask|uncaught runtime errors/i.test(text)
      && (/metamask/i.test(text) || /resizeobserver/i.test(text))
    ) {
      node.remove();
    }
  });
};

const handleWalletExtensionNoise = (event) => {
  const payload = event.reason ?? event.error ?? event.message;
  if (!isWalletExtensionNoise(payload) && !isExtensionConsoleNoise(payload, event.filename, event.lineno)) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  dismissDevErrorOverlay();
};

const patchConsole = () => {
  if (typeof window === 'undefined' || window.__extensionConsolePatched) {
    return;
  }
  window.__extensionConsolePatched = true;

  ['warn', 'error', 'log', 'info', 'debug'].forEach((method) => {
    const original = console[method];
    if (typeof original !== 'function') {
      return;
    }
    console[method] = (...args) => {
      if (isExtensionConsoleNoise(...args)) {
        return;
      }
      return original.apply(console, args);
    };
  });
};

const registerWalletExtensionErrorSuppression = () => {
  if (typeof window === 'undefined') {
    return;
  }
  patchConsole();
  if (window.__walletExtensionErrorsSuppressed) {
    return;
  }
  window.__walletExtensionErrorsSuppressed = true;

  window.addEventListener('unhandledrejection', handleWalletExtensionNoise, true);
  window.addEventListener('error', handleWalletExtensionNoise, true);
};

registerWalletExtensionErrorSuppression();

export {
  isWalletExtensionNoise,
  isExtensionConsoleNoise,
  isResizeObserverNoise,
  dismissDevErrorOverlay,
  registerWalletExtensionErrorSuppression,
};
